import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.Certifications.Pages.Nominations = createReactClass({
  propTypes() {},
  componentWillMount() {
    this.nominationsStore = Flux.Certifications.CertifierNominationsStore;
    return this.nominationsStore.initialize({}, this.forceUpdate, this);
  },
  componentWillUnmount() {
    return this.nominationsStore.cleanup(this.forceUpdate);
  },
  componentDidMount() {
    // This is fine for now, but if we let users fulfill their unused nominations,
    // This needs to get fetched after the data from the server gets back,
    // And looks like select2 doesn't support that, so this needs a hack
    // https://github.com/select2/select2/issues/2830
    // NOTE: the current implementation will still be functional
    // and not allow extra data to be sent to the server, because we disallow
    // adding new nominations at the store level, and then sync up the search bar with the store
    // as soon as spots become available. But select2 won't say that you can't nominate more people.
    const maxNominations = this.nominationsStore.totalNominations();
    this.searchView = new Search.UserSearch({
      el: $('#search'),
      placeholder: "Search by name...",
      maximumSelectionSize: maxNominations,
      minimumInputLength: 1,
      limit: 3,
      formatSelectionTooBig(limit) {
        return "You can only nominate " + $h.numberAndNoun(maxNominations, 'person');
      }
    });
    this.searchView.on('item-selected', this.addNominee, this);
    return this.searchView.on('item-removed', this.removeNominee, this);
  },
  addNominee(nominatedProfile) {
    return Flux.Dispatcher.dispatch({
      actionType: 'certifier-nominate',
      nominatedProfile
    });
  },
  removeNominee(removedProfile) {
    return Flux.Dispatcher.dispatch({
      actionType: 'certifier-remove-nomination',
      removedProfile
    });
  },
  render() {
    if (this.nominationsStore.hasData()) {
      return this.renderReady();
    } else {
      return this.renderLoading();
    }
  },
  renderLoading() {
    return /*#__PURE__*/_jsxs("div", {
      className: "DesignSystem",
      children: [this.header(), this.nominationFinder(), /*#__PURE__*/_jsx("label", {
        children: " Loading... "
      })]
    });
  },
  renderReady() {
    // Select2 hack: we can't dynamically limit the number of nominations,
    // So make sure the store and select2 are in sync on every render
    $("#search").select2('data', this.nominationsStore.takenNominations());
    return /*#__PURE__*/_jsxs("div", {
      className: "DesignSystem",
      children: [this.header(), this.nominationFinder(), this.nominationsList(), this.confirmButton()]
    });
  },
  header() {
    return /*#__PURE__*/_jsxs("div", {
      className: "u-fontSans",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "u-tcGrayDarkest u-mb2x u-mt1x",
        children: "Welcome to the endorser program!"
      }), /*#__PURE__*/_jsx("h5", {
        className: "u-tcGrayDarkest u-mt1x u-mb8x",
        children: "Is there anyone you would  like to see recommendations from?"
      })]
    });
  },
  nominationsLeftCounter() {
    const nominationsLeft = this.nominationsStore.nominationsLeft();
    const text = "You have " + $h.numberAndNoun(nominationsLeft, 'nomination') + " left";
    return /*#__PURE__*/_jsxs("label", {
      className: "u-tcBlue",
      children: [" ", text, " "]
    });
  },
  fetchingNominationsLeft() {
    return this.nominationsLeftCounter();
  },
  nominationFinder() {
    return /*#__PURE__*/_jsxs("div", {
      className: "Panel u-p8x",
      children: [this.nominationsLeftCounter(), /*#__PURE__*/_jsx("div", {
        className: "select2-no-default-pills",
        children: /*#__PURE__*/_jsx("div", {
          id: "search",
          style: {
            width: "100%"
          }
        })
      })]
    });
  },
  nominationsList() {
    const views = _.map(this.nominationsStore.nominations(), nomination => {
      return this.nomineeView(nomination);
    });
    views.reverse();
    return /*#__PURE__*/_jsx("div", {
      children: views
    });
  },
  nomineeView(nomination) {
    const nominatedProfile = nomination.attributes;
    nominatedProfile.display_name = nominatedProfile.name;
    nominatedProfile.photo = nominatedProfile.profile_pic_url;
    return /*#__PURE__*/_jsx("div", {
      className: "u-mt4x u-mb2x",
      children: /*#__PURE__*/_jsx("div", {
        className: "Panel u-p4x",
        children: this.profileWithDelete(nominatedProfile)
      })
    }, nominatedProfile.id);
  },
  profileWithDelete(profile) {
    const deleteHandler = () => {
      this.removeNominee(profile);
      // Black magic to remove the profile from select2
      // It doesn't support removing individual items programmatically by default.
      // https://github.com/select2/select2/issues/535
      const data = $('#search').select2("data");
      const newData = _.reject(data, entry => entry.id === profile.id);
      return $('#search').select2("data", newData);
    };
    return /*#__PURE__*/_jsxs("div", {
      className: "Media",
      children: [/*#__PURE__*/_jsx("div", {
        className: "Media--left Media--middle",
        children: /*#__PURE__*/_jsx(Certifications.Components.CertifierProfilePreview, {
          certifier: profile
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "Media--right Media--middle u-tcGray",
        children: /*#__PURE__*/_jsx(Components.Buttons.Delete, {
          handler: deleteHandler
        })
      })]
    });
  },
  confirmButton() {
    const nextPage = $r.certifications_suggestions_path();
    let text = "I don't want to nominate endorsers";
    let buttonClasses = "u-tcGrayDark";
    if (this.nominationsStore.madeNominations()) {
      text = "Send Nominations";
      buttonClasses = "Button Button--block Button--green Button--xl";
    }
    const classes = "u-taCenter clickable u-mt4x " + buttonClasses;
    return /*#__PURE__*/_jsx("label", {
      href: nextPage,
      className: classes,
      onClick: this.confirm,
      children: text
    });
  },
  confirm() {
    return Flux.Dispatcher.dispatch({
      actionType: 'certifier-nominations-confirm'
    });
  },
  displayName: "Nominations"
});
window._jsx = _jsx;
window._jsxs = _jsxs;